module.exports = __webpack_public_path__ + "static/media/email-sent-icon.8a33467f.svg";